import type { TypedDocumentNode } from '@apollo/client';
import gql from 'graphql-tag';

import type { TaskResponse } from 'common/components/TasksWidget/queries';
import { TaskFragment } from 'common/components/TasksWidget/queries';

export const cancelTaskMutation: TypedDocumentNode<CancelTaskResponse, { id: string }> = gql`
  mutation cancelTask($id: BinaryId!) {
    cancelTask(id: $id) {
      ...Task
    }
  }

  ${TaskFragment}
`;

export type CancelTaskResponse = {
  cancelTask: TaskResponse;
};

export const updateTaskStatus = gql`
  mutation updateTaskStatus($id: BinaryId!, $status: UpdatedTaskStatus!) {
    updateTaskStatus(id: $id, status: $status) {
      ...Task
    }
  }

  ${TaskFragment}
`;

export type UpdateTaskStatusResponse = {
  updateTaskStatus: TaskResponse;
};

export const dismissTask: TypedDocumentNode<DismissTaskResponse, { id: string }> = gql`
  mutation dismissTask($id: BinaryId!) {
    dismissTask(id: $id) {
      ...Task
    }
  }

  ${TaskFragment}
`;

export type DismissTaskResponse = {
  dismissTask: TaskResponse;
};
